import {Component, computed, effect, inject} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Alert, AlertService, AlertType} from '@innovactions/frontend-library';
import {ProfileManagement} from '../profile-management/profile-management';
import {Role} from '../../../enum/role';
import {CurrentUserService} from '../../../service/current-user';

@Component({
  selector: 'app-user-profile-management',
  standalone: true,
  imports: [CommonModule, ProfileManagement],
  templateUrl: './user-profile-management.html',
  styleUrl: './user-profile-management.scss'
})
export class UserProfileManagement {
  private readonly currentUserService = inject(CurrentUserService);
  private readonly alertService = inject(AlertService);

  protected readonly userId = computed(() => this.currentUserService.appUser()?.id ?? undefined);
  protected readonly loadError = this.currentUserService.hasAppUserLoadError;
  protected readonly careerProfileReadOnly = computed(() =>
    !this.currentUserService.hasAnyRole([Role.MANAGER]),
  );

  constructor() {
    effect(() => {
      if (this.currentUserService.hasAppUserLoadError()) {
        this.alertService.createAlert(
          new Alert(AlertType.ERROR, 'Profiel laden mislukt', 'Kon de gebruiker niet ophalen', false),
        );
      }
    });
  }
}
